// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-item-borderless>.ant-form-item {
    margin-bottom: 0;
  }`, "",{"version":3,"sources":["webpack://./client/modules/external-api/components/CreateClient.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;EAClB","sourcesContent":[":global .form-item-borderless>.ant-form-item {\n    margin-bottom: 0;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
